// Code Generated By 'npm run config', Please DO NOT Edit!!!!! 
        
const clientConfig = {
    appId: "cli_aab49ed4cc3b9ce4", //ISV应用appId
    getUserAccessTokenPath:  "/api/get_user_access_token", //免登api path
    getSignParametersPath:  "/api/get_sign_parameters", //鉴权api path;
    getTenantConfigPath: "/api/get_app_config", //获取租户配置的api path
    apiPort: "8990",   //前端请求本地Node.js后端的端口
}
    
export default clientConfig;